var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Button from '../button';
import Grid from '../grid';
import GridColumn from '../grid/column';
import Icon from '../icon';
import Label from '../label';
import { Styled } from './style';
export var ContentType;
(function (ContentType) {
    ContentType[ContentType["Playlist"] = 0] = "Playlist";
    ContentType[ContentType["Video"] = 1] = "Video";
    ContentType[ContentType["Image"] = 2] = "Image";
    ContentType[ContentType["App"] = 3] = "App";
    ContentType[ContentType["Doc"] = 4] = "Doc";
    ContentType[ContentType["Link"] = 5] = "Link";
})(ContentType || (ContentType = {}));
var ScreenController = /** @class */ (function (_super) {
    __extends(ScreenController, _super);
    function ScreenController(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOpenContent = _this.handleOpenContent.bind(_this);
        var labelUppercase = ContentType[_this.props.type].toUpperCase();
        _this.state = { labelName: labelUppercase };
        return _this;
    }
    ScreenController.prototype.renderChannel = function () {
        var channelName = this.props.channelName;
        var shouldRenderChannel = channelName && channelName !== '';
        return React.createElement("div", { className: "channel-container" }, shouldRenderChannel && React.createElement("span", null,
            "Channel -- ",
            channelName));
    };
    ScreenController.prototype.secondsToMinuteFormat = function (seconds) {
        var minutePart = Math.floor(seconds / 60);
        var secondPart = seconds % 60;
        return minutePart + ':' + (secondPart < 10 ? '0' : '') + secondPart;
    };
    ScreenController.prototype.handleOpenContent = function (url) {
        window.open(url, '_blank');
    };
    ScreenController.prototype.renderContent = function () {
        var _this = this;
        var _a = this.props, type = _a.type, playlistName = _a.playlistName, playlistDuration = _a.playlistDuration, contentTitle = _a.contentTitle, contentDuration = _a.contentDuration, contentUrl = _a.contentUrl;
        var labelName = this.state.labelName;
        switch (type) {
            case ContentType.Playlist:
                return (React.createElement("div", { className: "controller-playlist" },
                    React.createElement("div", { className: "playlist-container" },
                        React.createElement(Label, { size: "mini" }, labelName),
                        " ",
                        React.createElement("span", { className: "playlist-name" }, playlistName),
                        React.createElement(Icon, { name: "external", className: "playlist-openurl", onClick: function () { return _this.handleOpenContent(contentUrl); } }),
                        React.createElement("div", { className: "playlist-total" },
                            React.createElement(Icon, { name: "casting" }),
                            React.createElement("span", null, this.secondsToMinuteFormat(playlistDuration)))),
                    React.createElement(Grid, { columns: "equal", className: "content-container" },
                        React.createElement(GridColumn, null,
                            React.createElement(Icon, { name: "arrow-left", onClick: function (e) {
                                    return _this.props.callback(e, _this.props.contentId, _this.props.previousPlaylistId, 'previousPlaylist');
                                } })),
                        React.createElement(GridColumn, { width: 10, className: "content-title-wrapper" },
                            React.createElement("span", { className: "content-title" }, contentTitle),
                            React.createElement("span", { className: "content-duration" },
                                "-",
                                this.secondsToMinuteFormat(contentDuration))),
                        React.createElement(GridColumn, null,
                            React.createElement(Icon, { name: "arrow-right", onClick: function (e) {
                                    return _this.props.callback(e, _this.props.contentId, _this.props.nextPlaylistId, 'nextPlaylist');
                                } })))));
            case ContentType.Video:
            case ContentType.Image:
            case ContentType.App:
            case ContentType.Doc:
            case ContentType.Link:
                return (React.createElement("div", { className: "controller-generic" },
                    React.createElement("div", { className: "content-label" },
                        React.createElement(Label, { size: "mini" }, labelName),
                        " ",
                        playlistName),
                    React.createElement("div", { className: "content-container" },
                        React.createElement("div", { className: "content-title-wrapper" },
                            React.createElement("span", { className: "content-title" }, contentTitle),
                            React.createElement(Icon, { name: "external", className: "content-openurl", onClick: function () { return _this.handleOpenContent(contentUrl); } }),
                            React.createElement("span", { className: "content-duration" },
                                "-",
                                this.secondsToMinuteFormat(contentDuration))))));
            default:
                return undefined;
        }
    };
    ScreenController.prototype.render = function () {
        var _this = this;
        var _a = this.props;
        return (React.createElement(Styled, null,
            React.createElement("div", { className: "controller-container" },
                React.createElement("div", { className: "previous-button" },
                    React.createElement(Button, { circular: true, icon: true, onClick: function (e, d) {
                            return _this.props.callback(e, _this.props.contentId, _this.props.previousContentId, 'previousContent');
                        } },
                        React.createElement(Icon, { name: "skip-previous" }))),
                React.createElement("div", { className: "center-container" },
                    this.renderChannel(),
                    this.renderContent()),
                React.createElement("div", { className: "next-button" },
                    React.createElement(Button, { circular: true, icon: true, onClick: function (e, d) { return _this.props.callback(e, _this.props.contentId, _this.props.nextContentId, 'nextContent'); } },
                        React.createElement(Icon, { name: "skip-next" }))))));
    };
    return ScreenController;
}(React.Component));
export default ScreenController;
//# sourceMappingURL=index.js.map